import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import {
	type OpeningHour,
	useSpaceHours,
} from '~/domains/spaces/hooks/use-space-hours.hook'

export const SpaceHoursContent = ({ hours }: { hours: OpeningHour[] }) => {
	const { t } = useTranslation()

	return (
		<>
			{hours.map((spaceHour, i) => (
				<div
					key={i}
					className='flex flex-row gap-1'
				>
					<span>
						{`${[spaceHour.dayStart, spaceHour.dayEnd]
							.filter((el) => el)
							.map((day) => t(`common:dateTimes.weekdaysShort.${day}`))
							.join(' - ')} :`}
					</span>

					<span>
						{spaceHour.closed
							? t('space:closed')
							: spaceHour.open
									?.map((times) => [times.from, times.to].join(' - '))
									.join(', ')}
					</span>
				</div>
			))}
		</>
	)
}

export const SpaceHours = ({
	space,
}: { space: Pick<Space, 'hours' | 'desk_type'> }) => {
	const router = useRouter()
	const { t } = useTranslation()

	const isDesk = router.route === '/desks/[zone]/[slug]'

	const { spaceHours } = useSpaceHours({
		...(isDesk && space.desk_type === 'cocoon'
			? { ...space.hours, sat: { closed: true }, sun: { closed: true } }
			: space.hours),
	})

	return (
		<div className='flex flex-col gap-2 text-sm'>
			<h2 className='font-bold'>{t('space:sections.hours.title.long')}</h2>

			<SpaceHoursContent hours={spaceHours} />
		</div>
	)
}
